import { Info } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { useMediaQuery } from "@/hooks/use-media-query";
import { cn } from "@/lib/utils";

type ToofiInfoCueProps = {
  label?: string;
  explanation: string;
  className?: string;
};

export function ToofiInfoCue({ label = "Info", explanation, className }: ToofiInfoCueProps) {
  const isPhone = useMediaQuery("(max-width: 767px)");
  const trigger = (
    <button
      type="button"
      aria-label={label}
      className={cn(
        "student-guide-button",
        isPhone ? "h-4.5 w-4.5 text-slate-600" : "h-5 w-5",
        className,
      )}
    >
      <Info className={isPhone ? "h-2.5 w-2.5" : "h-2.5 w-2.5"} />
    </button>
  );

  if (isPhone) {
    return (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>{trigger}</DropdownMenuTrigger>
        <DropdownMenuContent
          align="start"
          sideOffset={8}
          className="student-floating-panel z-[120] max-w-[14rem] rounded-[1rem] px-3 py-2 text-[10px] leading-5 text-slate-600"
        >
          {explanation}
        </DropdownMenuContent>
      </DropdownMenu>
    );
  }

  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>{trigger}</TooltipTrigger>
        <TooltipContent className="student-floating-panel max-w-[15rem] rounded-[1rem] px-3 py-2 text-[11px] leading-5 text-slate-600">
          {explanation}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
